'use strict'

/**
 *
 * @name: nnBaseButton
 *
 */

import ButtonTemplate from './nn-base-button.button.directive.html'
import AnchorTemplate from './nn-base-button.anchor.directive.html'
import './nn-base-button.directive.scss'

function NnBaseButtonDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      solid: '=*',
      theme: '=*',
      href: '=*',
      icon: '=*',
      iconNoBorder: '=*'
    },
    template: (el, attr) => {
      return attr.href ? AnchorTemplate : ButtonTemplate
    },
    controller: nnBaseButtonDirectiveController
  }
}

function nnBaseButtonDirectiveController ($scope) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */

  $scope.className = () => ({
    ['nn-base-button--' + $scope.theme]: $scope.theme,
    'nn-base-button--solid': $scope.solid,
    'nn-base-button--with-icon': $scope.icon && !$scope.iconNoBorder,
    'nn-base-button--icon-no-border': $scope.iconNoBorder
  })



  /*
   *
   * @PUBLIC
   *
   */


  /*
   *
   * @PRIVATE
   *
   */



  /*
   *
   * @INIT
   *
   */

}

export default NnBaseButtonDirective



// WEBPACK FOOTER //
// ./app/components/nn-base-components/nn-base-button/nn-base-button.directive.js